import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import {
    FileTransfer,
    FileUploadOptions,
    FileTransferObject
} from '@ionic-native/file-transfer/ngx';
import { environment } from 'src/environments/environment';
import { Subscription, from, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAuthState } from 'src/modules/authentication/+store/auth.state';
import { transformImageWithDimensions } from '../utils/helpers/images.helper';


@Injectable({
    providedIn: 'root'
})
export class ImagesService {
    subscription: Subscription;
    token: string;
    constructor(
        private camera: Camera,
        private transfer: FileTransfer,
    ) { }

    choosePicture(srcType: string

        // 'CAMERA' | 'GALLERY'
    ) {
        const options: CameraOptions = {
            quality: 75,
            destinationType: this.camera.DestinationType.FILE_URI,
            sourceType: srcType === 'CAMERA' ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
            encodingType: this.camera.EncodingType.JPEG,
            targetWidth: 720,
            saveToPhotoAlbum: false,
            correctOrientation: true
        };

        return from(this.camera.getPicture(options)) as Observable<string>;
    }


    uploadPicture(imageData: string, token: string) {
        const fileTransfer: FileTransferObject = this.transfer.create();

        const uploadOptions: FileUploadOptions = {
            fileKey: 'images',
            fileName: 'avatar.jpeg',
            chunkedMode: true,
            mimeType: 'image/jpeg',
            headers: {
                Authorization: 'Bearer ' + token
            }
        };

        const server = environment.API_BASE_URL + '/api/users/avatar';
        const filePath = imageData;

        return from(fileTransfer.upload(
            filePath,
            server,
            uploadOptions
        ));


    }



    getProfilePic(profileUrl: { [key: string]: string }, dimensions?: string) {

        if (profileUrl && !profileUrl.error) {
            // Try .url first (Cloudinary HTTP), fall back to .secure_url (HTTPS / R2)
            const rawUrl = profileUrl.url || profileUrl.secure_url;
            if (rawUrl) {
                const imageSize = dimensions || 'w_300,h_300';
                return transformImageWithDimensions(rawUrl, imageSize);
            }
        }

        return ('assets/images/staffy-gray.png');
    }
}
